
    import './styles.scoped.css';
    export default {
  "arrow": "awsui_arrow_xjuzf_7t0qv_289",
  "arrow-outer": "awsui_arrow-outer_xjuzf_7t0qv_293",
  "arrow-inner": "awsui_arrow-inner_xjuzf_7t0qv_293",
  "arrow-position-right-top": "awsui_arrow-position-right-top_xjuzf_7t0qv_335",
  "arrow-position-right-bottom": "awsui_arrow-position-right-bottom_xjuzf_7t0qv_335",
  "arrow-position-left-top": "awsui_arrow-position-left-top_xjuzf_7t0qv_338",
  "arrow-position-left-bottom": "awsui_arrow-position-left-bottom_xjuzf_7t0qv_338",
  "arrow-position-top-center": "awsui_arrow-position-top-center_xjuzf_7t0qv_341",
  "arrow-position-top-right": "awsui_arrow-position-top-right_xjuzf_7t0qv_341",
  "arrow-position-top-left": "awsui_arrow-position-top-left_xjuzf_7t0qv_341",
  "arrow-position-top-responsive": "awsui_arrow-position-top-responsive_xjuzf_7t0qv_341",
  "arrow-position-bottom-center": "awsui_arrow-position-bottom-center_xjuzf_7t0qv_344",
  "arrow-position-bottom-right": "awsui_arrow-position-bottom-right_xjuzf_7t0qv_344",
  "arrow-position-bottom-left": "awsui_arrow-position-bottom-left_xjuzf_7t0qv_344",
  "arrow-position-bottom-responsive": "awsui_arrow-position-bottom-responsive_xjuzf_7t0qv_344",
  "body": "awsui_body_xjuzf_7t0qv_492",
  "body-overflow-visible": "awsui_body-overflow-visible_xjuzf_7t0qv_528",
  "has-dismiss": "awsui_has-dismiss_xjuzf_7t0qv_532",
  "dismiss": "awsui_dismiss_xjuzf_7t0qv_537",
  "dismiss-control": "awsui_dismiss-control_xjuzf_7t0qv_545",
  "header-row": "awsui_header-row_xjuzf_7t0qv_549",
  "header": "awsui_header_xjuzf_7t0qv_549",
  "content": "awsui_content_xjuzf_7t0qv_574",
  "content-overflow-visible": "awsui_content-overflow-visible_xjuzf_7t0qv_582",
  "container": "awsui_container_xjuzf_7t0qv_730",
  "container-arrow-position-bottom-left": "awsui_container-arrow-position-bottom-left_xjuzf_7t0qv_741",
  "container-arrow-position-bottom-center": "awsui_container-arrow-position-bottom-center_xjuzf_7t0qv_741",
  "container-arrow-position-bottom-right": "awsui_container-arrow-position-bottom-right_xjuzf_7t0qv_741",
  "container-arrow-position-top-left": "awsui_container-arrow-position-top-left_xjuzf_7t0qv_746",
  "container-arrow-position-top-center": "awsui_container-arrow-position-top-center_xjuzf_7t0qv_746",
  "container-arrow-position-top-right": "awsui_container-arrow-position-top-right_xjuzf_7t0qv_746",
  "container-arrow-position-right-top": "awsui_container-arrow-position-right-top_xjuzf_7t0qv_751",
  "container-arrow-position-right-bottom": "awsui_container-arrow-position-right-bottom_xjuzf_7t0qv_751",
  "container-arrow-position-left-top": "awsui_container-arrow-position-left-top_xjuzf_7t0qv_756",
  "container-arrow-position-left-bottom": "awsui_container-arrow-position-left-bottom_xjuzf_7t0qv_756",
  "container-body": "awsui_container-body_xjuzf_7t0qv_762",
  "container-body-variant-annotation": "awsui_container-body-variant-annotation_xjuzf_7t0qv_802",
  "container-body-size-small": "awsui_container-body-size-small_xjuzf_7t0qv_807",
  "fixed-width": "awsui_fixed-width_xjuzf_7t0qv_810",
  "container-body-size-medium": "awsui_container-body-size-medium_xjuzf_7t0qv_814",
  "container-body-size-large": "awsui_container-body-size-large_xjuzf_7t0qv_821",
  "container-arrow": "awsui_container-arrow_xjuzf_7t0qv_741",
  "container-arrow-position-top-responsive": "awsui_container-arrow-position-top-responsive_xjuzf_7t0qv_871",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_xjuzf_7t0qv_1",
  "refresh": "awsui_refresh_xjuzf_7t0qv_1065",
  "root": "awsui_root_xjuzf_7t0qv_1087",
  "no-wrap": "awsui_no-wrap_xjuzf_7t0qv_1119",
  "root-filtering-token": "awsui_root-filtering-token_xjuzf_7t0qv_1123",
  "trigger": "awsui_trigger_xjuzf_7t0qv_1127",
  "overflow-ellipsis": "awsui_overflow-ellipsis_xjuzf_7t0qv_1134",
  "trigger-type-text-inline": "awsui_trigger-type-text-inline_xjuzf_7t0qv_1142",
  "trigger-type-text": "awsui_trigger-type-text_xjuzf_7t0qv_1142",
  "trigger-type-filtering-token": "awsui_trigger-type-filtering-token_xjuzf_7t0qv_1210",
  "popover-inline-content": "awsui_popover-inline-content_xjuzf_7t0qv_1214"
};
  